import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthService } from './auth.service';

/**
 * Si una request al API responde 401 (token expirado o inválido), forzar
 * logout + full reload al /login. El reload duro evita que la app quede
 * en un estado intermedio: la nueva ruta carga limpia, sin componentes
 * "zombi" del estado autenticado anterior.
 */
export const authErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const auth = inject(AuthService);
  return next(req).pipe(
    catchError((err) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 401 &&
        !req.url.includes('/auth/login')
      ) {
        // Guard defensivo: si el 401 llega en una request que NO tenía
        // Authorization header, no es "token vencido" — es que el
        // interceptor de auth no matcheó la URL. Loguear en consola y
        // NO desloguear (evita bucles como el bug de dev del 2026-07-01
        // donde una whitelist hardcodeada dejaba pasar requests sin token
        // y este interceptor las interpretaba como "sesión inválida").
        if (!req.headers.has('Authorization')) {
          console.warn(
            '[auth] 401 en',
            req.url,
            '— request sin Authorization. Interceptor no adjuntó token. NO cerrando sesión.',
          );
          return throwError(() => err);
        }
        // `logout(true)` ya hace `window.location.href = '/login'`,
        // no necesitamos navegar más nada.
        auth.logout(true);
      }
      return throwError(() => err);
    }),
  );
};
